<script>
  import Snackbar, { Label, Actions } from "@smui/snackbar";
  import IconButton from "@smui/icon-button";
  let notification;
  let message;

  function handleMessage(event) {
    message = event.detail.message;
    console.log("error bar: ", message);
    notification.open();
  }
</script>

<style>

</style>

<svelte:window on:notify={handleMessage} />

<Snackbar bind:this={notification} labelText={message}>
  <Label />
  <Actions>
    <IconButton class="material-icons" title="Dismiss">close</IconButton>
  </Actions>
</Snackbar>
